<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown>
        <dropdown-action success icon="edit" @click="onClickEdit">Edit user</dropdown-action>

        <dropdown-action
          danger
          icon="delete"
          @click="onClickDelete"
          v-if="rowData.id != $store.state.auth.currentUser.id"
        >Delete user</dropdown-action>

        <dropdown-action
          danger
          icon="shield"
          @click="onClickBlock"
          v-if="!rowData.blocked && rowData.id != $store.state.auth.currentUser.id"
        >Block user</dropdown-action>

        <dropdown-action danger icon="shield" @click="onClickUnblock" v-else-if="rowData.id != $store.state.auth.currentUser.id">Unblock user</dropdown-action>
      </dropdown>
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";

import TrAction from "./TableRowAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";

export default {
  name: "user-actions",

  props: {
    rowData: Object
  },

  methods: {
    onClickEdit() {
      this.$router.push({
        name: "UserEdit",
        params: { userId: this.rowData.id }
      });
    },

    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("users/delete", {
              userId: vm.rowData.id
            })
            .then(resp => {
              this.$store.dispatch("users/list");
            });
        }
      });
    },

    onClickBlock() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store.dispatch("users/blockUser", vm.rowData.id).then(resp => {
            this.$store.dispatch("users/list");
          });
        }
      });
    },
    onClickUnblock() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("users/unblockUser", vm.rowData.id)
            .then(resp => {
              this.$store.dispatch("users/list");
            });
        }
      });
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin]
};
</script>
